import React, { useMemo, useRef } from "react";
import { AggregatedCategoryFilter } from "@components/pageHeader/filters/Tabs/CategoryFilter/AggregatedCategoryFilter";

import { ButtonProps } from "@components/general/Button/ButtonCore";
import {
    PopoverContainerHandle,
    PopoverContainer,
} from "@components/general/PopoverContainer";
import { CategoryFilterLabel } from "@components/general/ActiveFilters/CategoryFilterLabel";

interface CategoryDropdownProps {
    disabled?: boolean;
    categoryIds: string[];
    onChange: (categoryIds: string[]) => void;
    buttonSize?: ButtonProps["size"];
}

export const CategoryDropdown: React.FC<CategoryDropdownProps> = ({
    onChange,
    disabled,
    categoryIds,
    buttonSize,
}) => {
    const ref: React.ForwardedRef<PopoverContainerHandle | null> = useRef(null);
    const label = useMemo(
        () => (
            <div className="d-flex gap-2">
                {categoryIds.length === 0 ? (
                    <span>Select category</span>
                ) : (
                    <CategoryFilterLabel filters={{ category: categoryIds }} />
                )}
            </div>
        ),
        [categoryIds],
    );

    return (
        <PopoverContainer
            disabled={disabled}
            id="category-dropdown"
            buttonText={label}
            buttonSize={buttonSize ?? "lg"}
            offset={4}
            ref={ref}
        >
            <AggregatedCategoryFilter
                filters={{
                    category: categoryIds,
                }}
                onChange={(newFilters) => {
                    onChange(newFilters.category ?? []);
                }}
            />
        </PopoverContainer>
    );
};
